<template>
    <CardPage :section="14" :page="4">
        <p>
            Which of these tips do you think Billi might use in this situation?
            <span class="font-italic">Select all that apply</span>
        </p>
        <div v-for="(key, index) in tipsOrder" :key="index">
            <div v-if="'9' === key">
                <div
                    class="px-2 py-1 mb-1"
                    @click="select(tips[key])"
                    :class="{ secondary: !tips[key].selected, 'primary white--text': tips[key].selected }"
                    v-ripple
                    v-if="tips[key].value.length > 0"
                >
                    {{ tips[key].value }}
                </div>
            </div>
            <div v-else>
                <div
                    class="px-2 py-1 mb-1"
                    @click="select(tips[key])"
                    :class="{ secondary: !tips[key].selected, 'primary white--text': tips[key].selected }"
                    v-ripple
                >
                    {{ tips[key].text }}
                </div>
            </div>
        </div>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        tips: get('section14/tips'),
        tipsOrder: get('section14/tipsOrder')
    },
    methods: {
        select(tip) {
            this.$store.set(`section14/tips@${tip.id}.selected`, !this.$store.get(`section14/tips@${tip.id}.selected`));
        }
    }
};
</script>
